import Lottie from "lottie-react";

export default function LottieAnimator(props) {
	return (
		<>
			<Lottie animationData={props?.lottie} loop={true} className="w-100" />
		</>
	);
}
